import React, { useState, useEffect } from 'react';
import { Container, Card, Table, Button, Alert, Badge, Modal, Form, Row, Col } from 'react-bootstrap';
import { useAuth } from '../context/AuthContext';
import '../assets/css/KelolaTabs.css';
import { 
  collection, 
  query, 
  where, 
  getDocs, 
  doc, 
  updateDoc, 
  getDoc,
  setDoc,
  orderBy,
  deleteDoc,
  addDoc
} from 'firebase/firestore';
import { db } from '../firebase/config';
import { FaEye, FaCheck, FaTimes, FaUserPlus } from 'react-icons/fa';

const KelolaTugasAkhir = () => {
  const { currentUser, userRole } = useAuth();
  const [pendingTA, setPendingTA] = useState([]);
  const [approvedTA, setApprovedTA] = useState([]);
  const [dosenList, setDosenList] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [showDetailModal, setShowDetailModal] = useState(false);
  const [showAssignModal, setShowAssignModal] = useState(false);
  const [showRejectModal, setShowRejectModal] = useState(false);
  const [showApproveUsulanModal, setShowApproveUsulanModal] = useState(false);
  const [showRejectUsulanModal, setShowRejectUsulanModal] = useState(false);
  const [selectedTA, setSelectedTA] = useState(null);
  const [activeTab, setActiveTab] = useState('pending');
  const [selectedPembimbing, setSelectedPembimbing] = useState([]);
  const [rejectComment, setRejectComment] = useState('');
  const [rejectUsulanComment, setRejectUsulanComment] = useState('');
  const [showRejectPembimbingModal, setShowRejectPembimbingModal] = useState(false);
  const [rejectPembimbingComment, setRejectPembimbingComment] = useState('');
  const [loadedTabs, setLoadedTabs] = useState(new Set());

  useEffect(() => {
    // Hanya load dosen list saat pertama kali
    fetchDosenList();
    // Load data untuk tab aktif
    if (activeTab === 'pending') {
      fetchPendingData();
    } else if (activeTab === 'approved') {
      fetchApprovedData();
    }
  }, [currentUser, userRole]);

  // Fetch data ketika tab berubah
  useEffect(() => {
    if (!loadedTabs.has(activeTab)) {
      if (activeTab === 'pending') {
        fetchPendingData();
      } else if (activeTab === 'approved') {
        fetchApprovedData();
      }
    }
  }, [activeTab]);

  // Fetch dosen list (hanya sekali)
  const fetchDosenList = async () => {
    try {
      const dosenQuery = query(
        collection(db, "users"),
        where("role", "==", "dosen")
      );
      const dosenSnapshot = await getDocs(dosenQuery);
      
      const dosenData = [];
      dosenSnapshot.forEach(doc => {
        const userData = doc.data();
        if (userData.verified === true) {
          dosenData.push({
            id: doc.id,
            ...userData
          });
        }
      });
      
      setDosenList(dosenData);
    } catch (dosenError) {
      console.error("Error fetching dosen:", dosenError);
    }
  };

  // Fetch pending data
  const fetchPendingData = async () => {
    try {
      setLoading(true);
      setError('');
      
      const taQuery = query(collection(db, "tugasAkhir"));
      const taSnapshot = await getDocs(taQuery);
      
      const pendingData = [];
      
      taSnapshot.forEach(doc => {
        const taData = { id: doc.id, ...doc.data() };
        
        if (taData.status === "pending") {
          pendingData.push(taData);
        } else if (taData.status === "approved" || taData.status === "completed") {
          if (taData.usulanPerubahan && 
              (taData.usulanPerubahan.status === 'pending' || 
               taData.usulanPerubahan.status === 'pending_approval' || 
               taData.usulanPerubahan.status === 'pending_p1_approval')) {
            taData.originalStatus = taData.status;
            taData.hasUsulanPerubahanPending = true;
            taData.status = 'pending';
            pendingData.push(taData);
          } else if (taData.usulanPerubahanPembimbing && taData.usulanPerubahanPembimbing.status === 'pending') {
            taData.originalStatus = taData.status;
            taData.hasUsulanPerubahanPembimbingPending = true;
            taData.status = 'pending';
            pendingData.push(taData);
          }
        }
      });
      
      pendingData.sort((a, b) => {
        if (a.tanggal_daftar && b.tanggal_daftar) {
          return new Date(b.tanggal_daftar) - new Date(a.tanggal_daftar);
        }
        return 0;
      });
      
      // Ambil data mahasiswa, kandidat pembimbing, dan pembimbing yang ditugaskan
      for (const taData of pendingData) {
        if (taData.mahasiswaId) {
          try {
            const mahasiswaDoc = await getDoc(doc(db, "users", taData.mahasiswaId));
            if (mahasiswaDoc.exists()) {
              taData.mahasiswa = mahasiswaDoc.data();
            }
          } catch (error) {
            console.error(`Error fetching mahasiswa data for ${taData.id}:`, error);
          }
        }
        
        if (!taData.pembimbingId && taData.kandidatPembimbingId && Array.isArray(taData.kandidatPembimbingId)) {
          taData.kandidatPembimbing = [];
          for (const pembimbingId of taData.kandidatPembimbingId) {
            try {
              const dosenDoc = await getDoc(doc(db, "users", pembimbingId));
              if (dosenDoc.exists()) {
                taData.kandidatPembimbing.push({
                  id: pembimbingId,
                  ...dosenDoc.data()
                });
              }
            } catch (error) {
              console.error(`Error fetching kandidat pembimbing data for ${taData.id}:`, error);
            }
          }
        }
        
        if (taData.pembimbingId) {
          try {
            let pembimbingArr = [];
            if (Array.isArray(taData.pembimbingId)) {
              for (const pembimbingId of taData.pembimbingId) {
                const pembimbingDoc = await getDoc(doc(db, "users", pembimbingId));
                if (pembimbingDoc.exists()) {
                  pembimbingArr.push({ id: pembimbingId, ...pembimbingDoc.data() });
                }
              }
            } else if (typeof taData.pembimbingId === 'string') {
              const pembimbingDoc = await getDoc(doc(db, "users", taData.pembimbingId));
              if (pembimbingDoc.exists()) {
                pembimbingArr.push({ id: taData.pembimbingId, ...pembimbingDoc.data() });
              }
            }
            taData.pembimbing = pembimbingArr;
          } catch (error) {
            console.error(`Error fetching pembimbing data for ${taData.id}:`, error);
          }
        }
      }
      
      setPendingTA(pendingData);
      setLoadedTabs(prev => new Set([...prev, 'pending']));
      
    } catch (error) {
      console.error("Error fetching pending data:", error);
      setError("Terjadi kesalahan saat mengambil data pending");
    } finally {
      setLoading(false);
    }
  };

  // Fetch approved data
  const fetchApprovedData = async () => {
    try {
      setLoading(true);
      setError('');
      
      const taQuery = query(collection(db, "tugasAkhir"));
      const taSnapshot = await getDocs(taQuery);
      
      const approvedData = [];
      
      taSnapshot.forEach(doc => {
        const taData = { id: doc.id, ...doc.data() };
        
        if (taData.status === "approved" || taData.status === "completed") {
          // Skip jika ada usulan yang pending (akan ada di pending tab)
          const hasPendingUsulan = (taData.usulanPerubahan && 
                (taData.usulanPerubahan.status === 'pending' || 
                 taData.usulanPerubahan.status === 'pending_approval' || 
                 taData.usulanPerubahan.status === 'pending_p1_approval'));
          const hasPendingPerubahanPembimbing = (taData.usulanPerubahanPembimbing && 
                taData.usulanPerubahanPembimbing.status === 'pending');
          
          if (!hasPendingUsulan && !hasPendingPerubahanPembimbing) {
            approvedData.push(taData);
          }
        }
      });
      
      approvedData.sort((a, b) => {
        if (a.tanggal_daftar && b.tanggal_daftar) {
          return new Date(b.tanggal_daftar) - new Date(a.tanggal_daftar);
        }
        return 0;
      });
      
      // Ambil data mahasiswa, pembimbing, dan penguji
      for (const taData of approvedData) {
        if (taData.mahasiswaId) {
          try {
            const mahasiswaDoc = await getDoc(doc(db, "users", taData.mahasiswaId));
            if (mahasiswaDoc.exists()) {
              taData.mahasiswa = mahasiswaDoc.data();
            }
          } catch (error) {
            console.error(`Error fetching mahasiswa data for ${taData.id}:`, error);
          }
        }
        
        if (taData.pembimbingId) {
          try {
            let pembimbingArr = [];
            if (Array.isArray(taData.pembimbingId)) {
              for (const pembimbingId of taData.pembimbingId) {
                const pembimbingDoc = await getDoc(doc(db, "users", pembimbingId));
                if (pembimbingDoc.exists()) {
                  pembimbingArr.push({ id: pembimbingId, ...pembimbingDoc.data() });
                }
              }
            } else if (typeof taData.pembimbingId === 'string') {
              const pembimbingDoc = await getDoc(doc(db, "users", taData.pembimbingId));
              if (pembimbingDoc.exists()) {
                pembimbingArr.push({ id: taData.pembimbingId, ...pembimbingDoc.data() });
              }
            }
            taData.pembimbing = pembimbingArr;
          } catch (error) {
            console.error(`Error fetching pembimbing data for ${taData.id}:`, error);
          }
        }
        
        if (taData.pengujiId && taData.pengujiId.length > 0) {
          taData.penguji = [];
          for (const pengujiId of taData.pengujiId) {
            try {
              const pengujiDoc = await getDoc(doc(db, "users", pengujiId));
              if (pengujiDoc.exists()) {
                taData.penguji.push({
                  id: pengujiId,
                  ...pengujiDoc.data()
                });
              }
            } catch (error) {
              console.error(`Error fetching penguji data for ${taData.id}:`, error);
            }
          }
        }
      }
      
      setApprovedTA(approvedData);
      setLoadedTabs(prev => new Set([...prev, 'approved']));
      
    } catch (error) {
      console.error("Error fetching approved data:", error);
      setError("Terjadi kesalahan saat mengambil data approved");
    } finally {
      setLoading(false);
    }
  };

  // Wrapper untuk refresh data
  const fetchData = async () => {
    if (activeTab === 'pending') {
      await fetchPendingData();
    } else if (activeTab === 'approved') {
      await fetchApprovedData();
    }
  };

  const handleViewDetail = (ta) => {
    setSelectedTA(ta);
    setShowDetailModal(true);
  };

  const handleAssign = (ta) => {
    setSelectedTA(ta);
    // Initialize with candidate supervisors if they exist
    if (ta.kandidatPembimbingId && Array.isArray(ta.kandidatPembimbingId)) {
      setSelectedPembimbing(ta.kandidatPembimbingId);
    } else {
      setSelectedPembimbing([]);
    }
    setShowAssignModal(true);
  };

  const handleApprove = async () => {
    try {
      // PENGAMAN: Jangan izinkan approve jika tugas akhir sudah approved dan hanya ada usulan perubahan
      // Jika sudah approved dengan usulan perubahan, gunakan handleApproveUsulanPerubahan saja
      if (selectedTA.hasUsulanPerubahanPending || (selectedTA.originalStatus && selectedTA.originalStatus !== 'pending')) {
        setError("Tugas akhir ini sudah disetujui. Untuk usulan perubahan judul, gunakan tombol 'Setujui Usulan Perubahan' di modal detail.");
        setShowAssignModal(false);
        return;
      }
      
      // Validate selections
      if (!selectedPembimbing[0]) {
        setError("Pembimbing 1 (P1) wajib dipilih");
        return;
      }
      
      // Make sure pembimbing order is preserved correctly (no empty slots)
      const finalPembimbing = selectedPembimbing.filter(id => id !== "");
      
      console.log("Menyetujui tugas akhir:", selectedTA.id);
      console.log("Pembimbing:", finalPembimbing);
      
      // Cek apakah ada usulan perubahan yang perlu dihandle (hanya untuk tugas akhir yang benar-benar pending)
      const hasUsulanPerubahan = selectedTA.usulanPerubahan && selectedTA.usulanPerubahan.status === 'pending';
      const judulYangAkanDigunakan = hasUsulanPerubahan 
        ? selectedTA.usulanPerubahan.judul 
        : selectedTA.judul;
      const driveLinkYangAkanDigunakan = hasUsulanPerubahan 
        ? (selectedTA.usulanPerubahan.driveLink || selectedTA.driveLink)
        : selectedTA.driveLink;
      
      // 1. Update tugas akhir
      const updateData = {
        status: "approved",
        pembimbingId: finalPembimbing, // array of pembimbing with P1 as first element
        tanggal_approve: new Date().toISOString()
      };
      
      // Jika ada usulan perubahan, update juga judul dan driveLink
      if (hasUsulanPerubahan) {
        updateData.judul = judulYangAkanDigunakan;
        updateData.driveLink = driveLinkYangAkanDigunakan;
        updateData.usulanPerubahan = {
          ...selectedTA.usulanPerubahan,
          status: 'approved',
          tanggal_approve: new Date().toISOString(),
          approvedBy: currentUser.uid
        };
      }
      
      const taRef = doc(db, "tugasAkhir", selectedTA.id);
      await updateDoc(taRef, updateData);
      
      // 2. Buat entri bimbingan awal untuk setiap pembimbing
      // Ini akan membantu menampilkan data di halaman bimbingan dosen
      for (const pembimbingId of selectedPembimbing) {
        try {
          // Cari dosen untuk mendapatkan namanya
          const dosenDoc = await getDoc(doc(db, "users", pembimbingId));
          let dosenNama = "Dosen";
          if (dosenDoc.exists()) {
            dosenNama = dosenDoc.data().nama || "Dosen";
          }
          
          // Cari mahasiswa untuk mendapatkan namanya
          let mahasiswaNama = "Mahasiswa";
          if (selectedTA.mahasiswaId) {
            const mahasiswaDoc = await getDoc(doc(db, "users", selectedTA.mahasiswaId));
            if (mahasiswaDoc.exists()) {
              mahasiswaNama = mahasiswaDoc.data().nama || "Mahasiswa";
            }
          }
          
          // Buat entry bimbingan pengantar
          const bimbinganData = {
            tugasAkhirId: selectedTA.id,
            mahasiswaId: selectedTA.mahasiswaId,
            pembimbingId: pembimbingId,
            sesi: 0, // Sesi 0 untuk bimbingan pengantar
            judul: `Pengantar Bimbingan - ${judulYangAkanDigunakan}`,
            fileURL: driveLinkYangAkanDigunakan || "https://drive.google.com/",
            fileName: '',
            catatan: `Bimbingan awal untuk tugas akhir ${judulYangAkanDigunakan}. Silahkan mahasiswa membuat jadwal konsultasi dengan dosen pembimbing.`,
            status: 'completed', // Status completed agar muncul di daftar
            tanggal: new Date().toISOString(),
            tanggalRevisi: new Date(Date.now() + 7 * 24 * 60 * 60 * 1000).toISOString(), // 1 minggu kedepan
            reviewCatatan: `Selamat ${mahasiswaNama}, tugas akhir Anda telah disetujui. ${dosenNama} telah ditugaskan sebagai pembimbing Anda. Silakan membuat jadwal konsultasi.`,
            reviewDriveLink: '',
            tanggalReview: new Date().toISOString(),
            createdAt: new Date().toISOString(),
            createdBy: currentUser.uid,
            isIntroduction: true // Tandai ini sebagai bimbingan pengantar
          };
          
          console.log("Membuat bimbingan pengantar:", bimbinganData);
          
          // Tambahkan ke koleksi bimbingan
          await addDoc(collection(db, "bimbingan"), bimbinganData);
          console.log("Bimbingan pengantar berhasil dibuat untuk pembimbing:", pembimbingId);
        } catch (bimbinganError) {
          console.error("Error creating introduction bimbingan:", bimbinganError);
          // Lanjutkan meskipun ada error, tidak menghentikan proses persetujuan
        }
      }
      
      setSuccess("Tugas akhir berhasil disetujui dan dosen telah ditugaskan");
      
      // Refresh data
      fetchData();
      
      // Tutup modal
      setShowAssignModal(false);
    } catch (error) {
      console.error("Error approving tugas akhir:", error);
      setError("Terjadi kesalahan saat menyetujui tugas akhir: " + error.message);
    }
  };

  const handleShowRejectModal = (ta) => {
    setSelectedTA(ta);
    setRejectComment('');
    setShowRejectModal(true);
  };

  const handleReject = async () => {
    try {
      if (!selectedTA) return;
      
      const taRef = doc(db, "tugasAkhir", selectedTA.id);
      await updateDoc(taRef, {
        status: "rejected",
        tanggal_reject: new Date().toISOString(),
        komentar_penolakan: rejectComment || "Tidak ada komentar"
      });
      
      setSuccess("Tugas akhir berhasil ditolak");
      setRejectComment('');
      
      // Refresh data
      fetchData();
      
      // Tutup modal
      setShowRejectModal(false);
      if (showDetailModal) {
        setShowDetailModal(false);
      }
    } catch (error) {
      console.error("Error rejecting tugas akhir:", error);
      setError("Terjadi kesalahan saat menolak tugas akhir");
    }
  };

  // Fungsi untuk menyetujui usulan perubahan judul
  const handleApproveUsulanPerubahan = async (ta) => {
    try {
      if (!ta || !ta.usulanPerubahan || 
          (ta.usulanPerubahan.status !== 'pending' && ta.usulanPerubahan.status !== 'pending_approval')) {
        setError("Tidak ada usulan perubahan yang dapat disetujui");
        return;
      }

      const usulan = ta.usulanPerubahan;
      const judulBaru = usulan.judul;
      const judulLama = ta.judul;
      const driveLinkBaru = usulan.driveLink || ta.driveLink;

      setLoading(true);
      
      // 1. Update judul dan driveLink di dokument tugas akhir
      const taRef = doc(db, "tugasAkhir", ta.id);
      const updatedUsulanPerubahan = {
        ...usulan,
        status: 'approved',
        tanggal_approve: new Date().toISOString(),
        approvedBy: currentUser.uid
      };
      await updateDoc(taRef, {
        judul: judulBaru,
        driveLink: driveLinkBaru,
        usulanPerubahan: updatedUsulanPerubahan
      });

      // 2. Update semua referensi judul di bimbingan
      const bimbinganQuery = query(
        collection(db, "bimbingan"),
        where("tugasAkhirId", "==", ta.id)
      );
      const bimbinganSnapshot = await getDocs(bimbinganQuery);
      
      const bimbinganUpdates = [];
      bimbinganSnapshot.forEach((bimbinganDoc) => {
        const bimbinganData = bimbinganDoc.data();
        const updateData = {};
        
        // Update judul bimbingan
        if (bimbinganData.judul) {
          let updatedJudul = bimbinganData.judul;
          let needUpdate = false;
          
          // Case 1: Format "Pengantar Bimbingan - [JUDUL]" - selalu update karena format ini pasti menggunakan judul tugas akhir
          if (updatedJudul.startsWith('Pengantar Bimbingan - ')) {
            updatedJudul = `Pengantar Bimbingan - ${judulBaru}`;
            needUpdate = true;
          }
          // Case 2: Jika judul sama persis dengan judul lama (bukan format khusus)
          else if (updatedJudul === judulLama) {
            updatedJudul = judulBaru;
            needUpdate = true;
          }
          // Case 3: Jika judul mengandung judul lama (untuk format lain yang mungkin)
          else if (updatedJudul.includes(judulLama)) {
            // Escape special regex characters in judulLama
            const escapedJudulLama = judulLama.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
            updatedJudul = updatedJudul.replace(new RegExp(escapedJudulLama, 'g'), judulBaru);
            needUpdate = true;
          }
          
          if (needUpdate && updatedJudul !== bimbinganData.judul) {
            updateData.judul = updatedJudul;
          }
        }
        
        // Update catatan jika mengandung judul lama
        if (bimbinganData.catatan && bimbinganData.catatan.includes(judulLama)) {
          updateData.catatan = bimbinganData.catatan.replace(new RegExp(judulLama.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'), 'g'), judulBaru);
        }
        
        if (Object.keys(updateData).length > 0) {
          bimbinganUpdates.push(updateDoc(doc(db, "bimbingan", bimbinganDoc.id), updateData));
        }
      });

      // 3. Update semua referensi judul di seminar
      const seminarQuery = query(
        collection(db, "seminar"),
        where("tugasAkhirId", "==", ta.id)
      );
      const seminarSnapshot = await getDocs(seminarQuery);
      
      const seminarUpdates = [];
      seminarSnapshot.forEach((seminarDoc) => {
        const seminarData = seminarDoc.data();
        const updateData = {};
        
        // Update judulTA jika berbeda dengan judul baru
        if (seminarData.judulTA && seminarData.judulTA !== judulBaru) {
          updateData.judulTA = judulBaru;
        }
        
        if (Object.keys(updateData).length > 0) {
          seminarUpdates.push(updateDoc(doc(db, "seminar", seminarDoc.id), updateData));
        }
      });

      // Eksekusi semua update secara parallel
      await Promise.all([...bimbinganUpdates, ...seminarUpdates]);

      setSuccess(`Usulan perubahan judul berhasil disetujui. Judul telah diupdate dari "${judulLama}" menjadi "${judulBaru}"`);
      
      // Refresh data
      fetchData();
      
    } catch (error) {
      console.error("Error approving usulan perubahan:", error);
      setError("Terjadi kesalahan saat menyetujui usulan perubahan: " + error.message);
    } finally {
      setLoading(false);
    }
  };

  // Fungsi untuk menolak usulan perubahan judul
  const handleRejectUsulanPerubahan = async () => {
    try {
      if (!selectedTA || !selectedTA.usulanPerubahan) {
        setError("Tidak ada usulan perubahan yang dapat ditolak");
        return;
      }

      setLoading(true);
      
      const taRef = doc(db, "tugasAkhir", selectedTA.id);
      await updateDoc(taRef, {
        usulanPerubahan: {
          ...selectedTA.usulanPerubahan,
          status: 'rejected',
          tanggal_reject: new Date().toISOString(),
          rejectedBy: currentUser.uid,
          alasan: rejectUsulanComment || "Tidak ada alasan"
        }
      });

      setSuccess("Usulan perubahan judul berhasil ditolak");
      setRejectUsulanComment('');
      
      // Refresh data
      fetchData();
      
      // Tutup modal
      setShowRejectUsulanModal(false);
      
    } catch (error) {
      console.error("Error rejecting usulan perubahan:", error);
      setError("Terjadi kesalahan saat menolak usulan perubahan: " + error.message);
    } finally {
      setLoading(false);
    }
  };

  // Fungsi untuk menyetujui usulan perubahan pembimbing
  const handleApprovePerubahanPembimbing = async (ta) => {
    try {
      if (!ta || !ta.usulanPerubahanPembimbing || ta.usulanPerubahanPembimbing.status !== 'pending') {
        setError("Tidak ada usulan perubahan pembimbing yang dapat disetujui");
        return;
      }

      const usulan = ta.usulanPerubahanPembimbing;
      const pembimbingBaru = usulan.pembimbingBaruId;
      const pembimbingLama = usulan.pembimbingLamaId || [];

      setLoading(true);
      
      const taRef = doc(db, "tugasAkhir", ta.id);
      
      // 1. Simpan pembimbing lama ke history
      const pembimbingHistory = ta.pembimbingHistory || [];
      pembimbingHistory.push({
        pembimbingId: pembimbingLama,
        tanggalPerubahan: new Date().toISOString(),
        digantikanOleh: pembimbingBaru,
        alasan: "Perubahan pembimbing"
      });
      
      // 2. Update pembimbingId dengan pembimbing baru
      await updateDoc(taRef, {
        pembimbingId: pembimbingBaru,
        pembimbingHistory: pembimbingHistory,
        usulanPerubahanPembimbing: {
          ...usulan,
          status: 'approved',
          tanggal_approve: new Date().toISOString(),
          approvedBy: currentUser.uid
        }
      });

      // 3. Update semua bimbingan lama untuk menandai sebagai pembimbing lama
      const bimbinganQuery = query(
        collection(db, "bimbingan"),
        where("tugasAkhirId", "==", ta.id)
      );
      const bimbinganSnapshot = await getDocs(bimbinganQuery);
      
      const bimbinganUpdates = [];
      bimbinganSnapshot.forEach((bimbinganDoc) => {
        const bimbinganData = bimbinganDoc.data();
        // Mark bimbingan dengan pembimbing lama sebagai tidak aktif untuk pembimbing lama
        if (bimbinganData.pembimbingId && pembimbingLama.includes(bimbinganData.pembimbingId)) {
          bimbinganUpdates.push(updateDoc(doc(db, "bimbingan", bimbinganDoc.id), {
            pembimbingLama: true,
            tanggalPerubahanPembimbing: new Date().toISOString(),
            pembimbingBaru: pembimbingBaru
          }));
        }
      });

      // 4. Eksekusi semua update bimbingan
      if (bimbinganUpdates.length > 0) {
        await Promise.all(bimbinganUpdates);
      }

      // 5. Update data pembimbing (array of objects) di tugasAkhir
      const pembimbingBaruData = [];
      for (const pembimbingId of pembimbingBaru) {
        try {
          const pembimbingDoc = await getDoc(doc(db, "users", pembimbingId));
          if (pembimbingDoc.exists()) {
            const pembimbingData = pembimbingDoc.data();
            pembimbingBaruData.push({
              id: pembimbingId,
              nama: pembimbingData.nama || 'Dosen',
              nip: pembimbingData.nip || '-'
            });
          }
        } catch (error) {
          console.error(`Error fetching pembimbing data for ${pembimbingId}:`, error);
        }
      }
      
      if (pembimbingBaruData.length > 0) {
        await updateDoc(taRef, {
          pembimbing: pembimbingBaruData
        });
      }

      // 6. Buat bimbingan pengantar untuk pembimbing baru jika belum ada
      const existingBimbinganQuery = query(
        collection(db, "bimbingan"),
        where("tugasAkhirId", "==", ta.id),
        where("isIntroduction", "==", true)
      );
      const existingBimbinganSnapshot = await getDocs(existingBimbinganQuery);
      
      // Cek apakah sudah ada bimbingan pengantar untuk pembimbing baru
      let needsIntroductionBimbingan = true;
      for (const bimbinganDoc of existingBimbinganSnapshot.docs) {
        const bimbinganData = bimbinganDoc.data();
        if (pembimbingBaru.includes(bimbinganData.pembimbingId) && !bimbinganData.pembimbingLama) {
          needsIntroductionBimbingan = false;
          break;
        }
      }
      
      if (needsIntroductionBimbingan) {
        // Buat bimbingan pengantar untuk setiap pembimbing baru
        for (const pembimbingId of pembimbingBaru) {
          try {
            const dosenDoc = await getDoc(doc(db, "users", pembimbingId));
            let dosenNama = "Dosen";
            if (dosenDoc.exists()) {
              dosenNama = dosenDoc.data().nama || "Dosen";
            }
            
            const mahasiswaDoc = await getDoc(doc(db, "users", ta.mahasiswaId));
            let mahasiswaNama = "Mahasiswa";
            if (mahasiswaDoc.exists()) {
              mahasiswaNama = mahasiswaDoc.data().nama || "Mahasiswa";
            }
            
            const bimbinganData = {
              tugasAkhirId: ta.id,
              mahasiswaId: ta.mahasiswaId,
              pembimbingId: pembimbingId,
              sesi: 0,
              judul: `Pengantar Bimbingan - ${ta.judul}`,
              fileURL: ta.driveLink || "https://drive.google.com/",
              fileName: '',
              catatan: `Bimbingan awal untuk tugas akhir ${ta.judul}. Pembimbing baru setelah perubahan pembimbing.`,
              status: 'reviewed',
              tanggal: new Date().toISOString(),
              tanggalRevisi: new Date(Date.now() + 7 * 24 * 60 * 60 * 1000).toISOString(),
              reviewCatatan: `Selamat ${mahasiswaNama}, pembimbing Anda telah diubah. ${dosenNama} telah menjadi pembimbing baru Anda. Silakan membuat jadwal konsultasi.`,
              reviewDriveLink: '',
              tanggalReview: new Date().toISOString(),
              createdAt: new Date().toISOString(),
              isIntroduction: true
            };
            
            await addDoc(collection(db, "bimbingan"), bimbinganData);
          } catch (error) {
            console.error(`Error creating introduction bimbingan for pembimbing ${pembimbingId}:`, error);
          }
        }
      }

      setSuccess(`Usulan perubahan pembimbing berhasil disetujui. Pembimbing telah diupdate.`);
      
      // Refresh data
      fetchData();
      
    } catch (error) {
      console.error("Error approving perubahan pembimbing:", error);
      setError("Terjadi kesalahan saat menyetujui usulan perubahan pembimbing: " + error.message);
    } finally {
      setLoading(false);
    }
  };

  // Fungsi untuk menolak usulan perubahan pembimbing
  const handleRejectPerubahanPembimbing = async () => {
    try {
      if (!selectedTA || !selectedTA.usulanPerubahanPembimbing) {
        setError("Tidak ada usulan perubahan pembimbing yang dapat ditolak");
        return;
      }

      setLoading(true);
      
      const taRef = doc(db, "tugasAkhir", selectedTA.id);
      await updateDoc(taRef, {
        usulanPerubahanPembimbing: {
          ...selectedTA.usulanPerubahanPembimbing,
          status: 'rejected',
          tanggal_reject: new Date().toISOString(),
          rejectedBy: currentUser.uid,
          alasan: rejectPembimbingComment || "Tidak ada alasan"
        }
      });

      setSuccess("Usulan perubahan pembimbing berhasil ditolak");
      setShowRejectPembimbingModal(false);
      setRejectPembimbingComment('');
      
      // Refresh data
      fetchData();
      
    } catch (error) {
      console.error("Error rejecting perubahan pembimbing:", error);
      setError("Terjadi kesalahan saat menolak usulan perubahan pembimbing: " + error.message);
    } finally {
      setLoading(false);
    }
  };

  // Modified to handle specific role selection (P1 or P2)
  const handlePembimbingChange = (e) => {
    const value = e.target.value;
    const roleIndex = parseInt(e.target.getAttribute('data-role-index'));
    
    // Create a copy of current selections
    const newSelection = [...selectedPembimbing];
    
    // Set the specific position (P1 or P2)
    if (value === "") {
      // If empty value, remove that position
      if (newSelection.length > roleIndex) {
        newSelection.splice(roleIndex, 1);
      }
    } else {
      // If user already selected as another role, remove from previous position
      const existingIndex = newSelection.indexOf(value);
      if (existingIndex !== -1 && existingIndex !== roleIndex) {
        newSelection.splice(existingIndex, 1);
      }
      
      // Ensure array has enough elements
      while (newSelection.length <= roleIndex) {
        newSelection.push("");
      }
      
      // Set new value at specific position
      newSelection[roleIndex] = value;
    }
    
    // Filter out empty values
    setSelectedPembimbing(newSelection.filter(id => id !== ""));
    
    console.log("Updated pembimbing selection:", newSelection);
  };


  const renderStatusBadge = (status) => {
    switch (status) {
      case 'pending':
        return <Badge bg="warning">Menunggu Persetujuan</Badge>;
      case 'approved':
        return <Badge bg="success">Disetujui</Badge>;
      case 'rejected':
        return <Badge bg="danger">Ditolak</Badge>;
      case 'completed':
        return <Badge bg="primary">Selesai</Badge>;
      default:
        return <Badge bg="secondary">Unknown</Badge>;
    }
  };

  // Menghapus tugas akhir dari Firestore
  const handleDeleteTA = async (ta) => {
    if (!window.confirm('Yakin ingin menghapus tugas akhir ini?')) return;
    try {
      setLoading(true);
      await deleteDoc(doc(db, "tugasAkhir", ta.id));
      setSuccess('Tugas akhir berhasil dihapus');
      fetchData();
    } catch (error) {
      console.error('Error deleting tugas akhir:', error);
      setError('Terjadi kesalahan saat menghapus tugas akhir');
    } finally {
      setLoading(false);
    }
  };

  const renderPendingTable = () => {
    return (
      <Table striped bordered hover responsive>
        <thead>
          <tr>
            <th>No</th>
            <th>Judul</th>
            <th>Mahasiswa</th>
            <th>Tanggal Daftar</th>
            <th>Status</th>
            <th>Aksi</th>
          </tr>
        </thead>
        <tbody>
          {pendingTA.length > 0 ? (
            pendingTA.map((ta, index) => {
              // Tampilkan judul dari usulan perubahan jika ada yang pending
              const displayJudul = ta.usulanPerubahan && ta.usulanPerubahan.status === 'pending' 
                ? ta.usulanPerubahan.judul 
                : ta.judul;
              const hasUsulanPending = ta.usulanPerubahan && ta.usulanPerubahan.status === 'pending';
              // Cek apakah ini tugas akhir yang benar-benar pending atau sudah approved dengan usulan perubahan
              const isTruePending = !ta.hasUsulanPerubahanPending && ta.status === 'pending';
              
              return (
              <tr key={ta.id}>
                <td>{index + 1}</td>
                <td>
                  {displayJudul}
                  {hasUsulanPending && (
                    <Badge bg="info" className="ms-2">Usulan Perubahan</Badge>
                  )}
                </td>
                <td>
                  {ta.mahasiswa ? (
                    <>
                      {ta.mahasiswa.nama}<br />
                      <small className="text-muted">{ta.mahasiswa.nim}</small>
                    </>
                  ) : (
                    <span className="text-muted">Data mahasiswa tidak ditemukan</span>
                  )}
                </td>
                <td>{new Date(ta.tanggal_daftar).toLocaleDateString('id-ID')}</td>
                <td>{renderStatusBadge(ta.status)}</td>
                <td>
                  <Button 
                    variant="info" 
                    size="sm" 
                    className="me-2"
                    onClick={() => handleViewDetail(ta)}
                  >
                    <FaEye /> Detail
                  </Button>
                  {/* Hanya tampilkan tombol Tugaskan untuk tugas akhir yang benar-benar pending (belum approved) */}
                  {isTruePending && (
                    <Button 
                      variant="success" 
                      size="sm" 
                      className="me-2"
                      onClick={() => handleAssign(ta)}
                    >
                      <FaUserPlus /> Tugaskan
                    </Button>
                  )}
                  {/* Hanya tampilkan tombol Tolak untuk tugas akhir yang benar-benar pending */}
                  {isTruePending && (
                    <Button 
                      variant="danger" 
                      size="sm"
                      className="me-2"
                      onClick={() => handleShowRejectModal(ta)}
                    >
                      <FaTimes /> Tolak
                    </Button>
                  )}
                  <Button 
                    variant="danger" 
                    size="sm"
                    className={isTruePending ? "ms-2" : "me-2"}
                    onClick={() => handleDeleteTA(ta)}
                  >
                    <FaTimes /> Hapus
                  </Button>
                </td>
              </tr>
              );
            })
          ) : (
            <tr>
              <td colSpan="6" className="text-center">Tidak ada tugas akhir yang menunggu persetujuan</td>
            </tr>
          )}
        </tbody>
      </Table>
    );
  };

  const renderApprovedTable = () => {
    return (
      <Table striped bordered hover responsive>
        <thead>
          <tr>
            <th>No</th>
            <th>Judul</th>
            <th>Mahasiswa</th>
            <th>Pembimbing</th>
            <th>Aksi</th>
          </tr>
        </thead>
        <tbody>
          {approvedTA.length > 0 ? (
            approvedTA.map((ta, index) => (
              <tr key={ta.id}>
                <td>{index + 1}</td>
                <td>{ta.judul}</td>
                <td>
                  {ta.mahasiswa ? (
                    <>
                      {ta.mahasiswa.nama}<br />
                      <small className="text-muted">{ta.mahasiswa.nim}</small>
                    </>
                  ) : (
                    <span className="text-muted">Data mahasiswa tidak ditemukan</span>
                  )}
                </td>
                <td>
                  {Array.isArray(ta.pembimbing) && ta.pembimbing.length > 0 ? (
                    <ul className="mb-0 list-unstyled">
                      {ta.pembimbing.map((p, idx) => (
                        <li key={p.id}>
                          <div className="d-flex align-items-center">
                            <Badge bg={idx === 0 ? "primary" : "secondary"} className="me-2">
                              {idx === 0 ? "P1" : "P2"}
                            </Badge>
                            <div>
                              {p.nama} <br />
                              <small className="text-muted">NIP: {p.nip}</small>
                            </div>
                          </div>
                        </li>
                      ))}
                    </ul>
                  ) : (
                    <span className="text-muted">Data pembimbing tidak ditemukan</span>
                  )}
                </td>
                <td>
                  <Button 
                    variant="primary" 
                    size="sm"
                    className="me-2"
                    onClick={() => handleAssign(ta)}
                  >
                    Edit
                  </Button>
                  <Button 
                    variant="danger" 
                    size="sm"
                    onClick={() => handleDeleteTA(ta)}
                  >
                    Hapus
                  </Button>
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="5" className="text-center">Tidak ada tugas akhir yang disetujui</td>
            </tr>
          )}
        </tbody>
      </Table>
    );
  };

  const renderDetailModal = () => {
    if (!selectedTA) return null;
    
    return (
      <Modal show={showDetailModal} onHide={() => setShowDetailModal(false)} size="lg">
        <Modal.Header closeButton>
          <Modal.Title>Detail Tugas Akhir</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Row>
            <Col md={12}>
              <h5 className="mb-3">
                {selectedTA.usulanPerubahan && 
                 (selectedTA.usulanPerubahan.status === 'pending' || 
                  selectedTA.usulanPerubahan.status === 'pending_approval' ||
                  selectedTA.usulanPerubahan.status === 'pending_p1_approval')
                  ? selectedTA.usulanPerubahan.judul 
                  : selectedTA.judul}
                {selectedTA.usulanPerubahan && 
                 (selectedTA.usulanPerubahan.status === 'pending' || 
                  selectedTA.usulanPerubahan.status === 'pending_approval' ||
                  selectedTA.usulanPerubahan.status === 'pending_p1_approval') && (
                  <Badge bg="info" className="ms-2">
                    {selectedTA.usulanPerubahan.status === 'pending_approval' ? 
                      'Usulan Perubahan (Sudah Disetujui P1)' : 
                      selectedTA.usulanPerubahan.status === 'pending_p1_approval' ?
                      'Usulan Perubahan (Menunggu P1)' :
                      'Usulan Perubahan'}
                  </Badge>
                )}
              </h5>
              <p className="text-muted">Status: {renderStatusBadge(selectedTA.status)}</p>
            </Col>
          </Row>

          {/* Tampilkan usulan perubahan jika ada */}
          {selectedTA.usulanPerubahan && 
           (selectedTA.usulanPerubahan.status === 'pending' || 
            selectedTA.usulanPerubahan.status === 'pending_approval' ||
            selectedTA.usulanPerubahan.status === 'pending_p1_approval') && (
            <>
              <Row className="mb-3">
                <Col md={12}>
                  <Alert variant="info">
                    <strong>Usulan Perubahan Judul:</strong>
                    <div className="mt-2">
                      <strong>Judul Lama:</strong> {selectedTA.judul}
                    </div>
                    <div className="mt-2">
                      <strong>Judul Baru (Usulan):</strong> {selectedTA.usulanPerubahan.judul}
                    </div>
                    <div className="mt-2">
                      <strong>Link Drive (Usulan):</strong> 
                      <a href={selectedTA.usulanPerubahan.driveLink} target="_blank" rel="noopener noreferrer" className="ms-2">
                        {selectedTA.usulanPerubahan.driveLink}
                      </a>
                    </div>
                    <div className="mt-2">
                      <small className="text-muted">
                        Diajukan pada: {new Date(selectedTA.usulanPerubahan.tanggal_usulan).toLocaleString('id-ID')}
                      </small>
                    </div>
                  </Alert>
                </Col>
              </Row>
              <Row className="mb-3">
                <Col md={12} className="d-flex gap-2">
                  <Button 
                    variant="success" 
                    onClick={() => {
                      setShowDetailModal(false);
                      handleApproveUsulanPerubahan(selectedTA);
                    }}
                  >
                    <FaCheck /> Setujui Usulan Perubahan
                  </Button>
                  <Button 
                    variant="danger" 
                    onClick={() => {
                      setShowDetailModal(false);
                      setSelectedTA(selectedTA);
                      setShowRejectUsulanModal(true);
                    }}
                  >
                    <FaTimes /> Tolak Usulan Perubahan
                  </Button>
                </Col>
              </Row>
            </>
          )}
          
          {/* Tampilkan usulan perubahan pembimbing jika ada */}
          {selectedTA.usulanPerubahanPembimbing && selectedTA.usulanPerubahanPembimbing.status === 'pending' && (
            <>
              <Row className="mb-3">
                <Col md={12}>
                  <Alert variant="warning">
                    <strong>Usulan Perubahan Pembimbing:</strong>
                    <div className="mt-2">
                      <strong>Pembimbing Lama:</strong>
                      <ul className="mt-1">
                        {selectedTA.usulanPerubahanPembimbing.pembimbingLamaId && 
                         Array.isArray(selectedTA.usulanPerubahanPembimbing.pembimbingLamaId) &&
                         selectedTA.usulanPerubahanPembimbing.pembimbingLamaId.map((pId, idx) => {
                           const pembimbingLama = Array.isArray(selectedTA.pembimbing) ? 
                                                  selectedTA.pembimbing.find(p => p.id === pId) : null;
                           return (
                             <li key={pId}>
                               {pembimbingLama ? `${pembimbingLama.nama} (NIP: ${pembimbingLama.nip || '-'})` : `Pembimbing ${idx+1} (ID: ${pId})`}
                             </li>
                           );
                         })}
                      </ul>
                    </div>
                    <div className="mt-2">
                      <strong>Pembimbing Baru (Usulan):</strong>
                      <ul className="mt-1">
                        {selectedTA.usulanPerubahanPembimbing.pembimbingBaruId && 
                         Array.isArray(selectedTA.usulanPerubahanPembimbing.pembimbingBaruId) &&
                         selectedTA.usulanPerubahanPembimbing.pembimbingBaruId.map((pId, idx) => {
                           const dosenBaru = dosenList.find(d => d.id === pId);
                           return (
                             <li key={pId}>
                               {dosenBaru ? `${dosenBaru.nama} (NIP: ${dosenBaru.nip || '-'})` : `Pembimbing ${idx+1} (ID: ${pId})`}
                             </li>
                           );
                         })}
                      </ul>
                    </div>
                    <div className="mt-2">
                      <small className="text-muted">
                        Diajukan pada: {new Date(selectedTA.usulanPerubahanPembimbing.tanggal_usulan).toLocaleString('id-ID')}
                      </small>
                    </div>
                  </Alert>
                </Col>
              </Row>
              <Row className="mb-3">
                <Col md={12} className="d-flex gap-2">
                  <Button 
                    variant="success" 
                    onClick={() => {
                      setShowDetailModal(false);
                      handleApprovePerubahanPembimbing(selectedTA);
                    }}
                  >
                    <FaCheck /> Setujui Perubahan Pembimbing
                  </Button>
                  <Button 
                    variant="danger" 
                    onClick={() => {
                      setShowDetailModal(false);
                      setSelectedTA(selectedTA);
                      setShowRejectPembimbingModal(true);
                    }}
                  >
                    <FaTimes /> Tolak Perubahan Pembimbing
                  </Button>
                </Col>
              </Row>
            </>
          )}
          
          <Row className="mb-3">
            <Col md={3} className="fw-bold">Mahasiswa</Col>
            <Col md={9}>
              {selectedTA.mahasiswa ? (
                <>
                  {selectedTA.mahasiswa.nama}<br />
                  <small className="text-muted">{selectedTA.mahasiswa.nim}</small><br />
                  <small className="text-muted">Program Studi: {selectedTA.mahasiswa.prodi}</small>
                </>
              ) : (
                <span className="text-muted">Data mahasiswa tidak ditemukan</span>
              )}
            </Col>
          </Row>

          {/* Tampilkan pembimbing yang ditugaskan jika sudah ada, atau kandidat jika belum ada */}
          {(() => {
            // Cek apakah sudah ada pembimbing yang ditugaskan (cek pembimbingId atau pembimbing array)
            const hasAssignedPembimbing = (selectedTA.pembimbingId && 
                                           (Array.isArray(selectedTA.pembimbingId) ? selectedTA.pembimbingId.length > 0 : true)) ||
                                           (Array.isArray(selectedTA.pembimbing) && selectedTA.pembimbing.length > 0);
            
            if (hasAssignedPembimbing) {
              // Tampilkan pembimbing yang sudah ditugaskan
              return (
                <>
                  <Row className="mb-3">
                    <Col md={3} className="fw-bold">Pembimbing</Col>
                    <Col md={9}>
                      {Array.isArray(selectedTA.pembimbing) && selectedTA.pembimbing.length > 0 ? (
                        <ul className="mb-0 list-unstyled">
                          {selectedTA.pembimbing.map((p, idx) => (
                            <li key={p.id}>
                              <div className="d-flex align-items-center">
                                <Badge bg={idx === 0 ? "primary" : "secondary"} className="me-2">
                                  {idx === 0 ? "P1" : "P2"}
                                </Badge>
                                <div>
                                  {p.nama} <br />
                                  <small className="text-muted">NIP: {p.nip}</small>
                                </div>
                              </div>
                            </li>
                          ))}
                        </ul>
                      ) : (
                        <span className="text-muted">Data pembimbing tidak ditemukan</span>
                      )}
                    </Col>
                  </Row>
                  <Row className="mb-3">
                    <Col md={12}>
                      <div className="alert alert-info">
                        <strong>Catatan:</strong> Penugasan dosen penguji dilakukan pada saat seminar dijadwalkan di menu Kelola Seminar.
                      </div>
                    </Col>
                  </Row>
                </>
              );
            } else {
              // Tampilkan kandidat pembimbing jika belum ada yang ditugaskan
              return (
                <Row className="mb-3">
                  <Col md={3} className="fw-bold">Kandidat Pembimbing</Col>
                  <Col md={9}>
                    {selectedTA.kandidatPembimbing && selectedTA.kandidatPembimbing.length > 0 ? (
                      <ul className="mb-0 ps-3">
                        {selectedTA.kandidatPembimbing.map((p, idx) => (
                          <li key={idx}>
                            {p.nama} {p.nip && <small className="text-muted">({p.nip})</small>}
                          </li>
                        ))}
                      </ul>
                    ) : selectedTA.kandidatPembimbingId && selectedTA.kandidatPembimbingId.length > 0 ? (
                      <ul className="mb-0 ps-3">
                        {selectedTA.kandidatPembimbingId.map((id, idx) => {
                          const dosen = dosenList.find(d => d.id === id);
                          return (
                            <li key={idx}>
                              {dosen ? (
                                <>
                                  {dosen.nama} {dosen.nip && <small className="text-muted">({dosen.nip})</small>}
                                </>
                              ) : (
                                <>ID Dosen: {id} <small className="text-muted">(data tidak ditemukan)</small></>
                              )}
                            </li>
                          );
                        })}
                      </ul>
                    ) : (
                      <span className="text-muted">Tidak ada kandidat pembimbing yang dipilih</span>
                    )}
                    <div className="mt-2">
                      <small className="text-info">Mahasiswa telah memilih kandidat pembimbing. Anda dapat menentukan pembimbing yang akan ditugaskan.</small>
                    </div>
                  </Col>
                </Row>
              );
            }
          })()}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowDetailModal(false)}>
            Tutup
          </Button>
        </Modal.Footer>
      </Modal>
    );
  };

  const renderAssignModal = () => {
    if (!selectedTA) return null;
    
    return (
      <Modal show={showAssignModal} onHide={() => setShowAssignModal(false)} size="lg">
        <Modal.Header closeButton>
          <Modal.Title>Tugaskan Dosen</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Row>
            <Col md={12}>
              <h5 className="mb-3">{selectedTA.judul}</h5>
              <p>
                Mahasiswa: {selectedTA.mahasiswa ? selectedTA.mahasiswa.nama : 'Data mahasiswa tidak ditemukan'}
                {selectedTA.mahasiswa && <span className="text-muted"> ({selectedTA.mahasiswa.nim})</span>}
              </p>
            </Col>
          </Row>
          
          {error && <Alert variant="danger">{error}</Alert>}
          
          {/* Display candidate supervisors if available */}
          {selectedTA.kandidatPembimbing && selectedTA.kandidatPembimbing.length > 0 && (
            <div className="mb-4">
              <Alert variant="info">
                <strong>Kandidat Dosen Pembimbing yang Dipilih Mahasiswa:</strong>
                <ul className="mb-0 mt-2">
                  {selectedTA.kandidatPembimbing.map((p, idx) => (
                    <li key={idx}>
                      {p.nama} {p.nip && <span className="text-muted">({p.nip})</span>}
                    </li>
                  ))}
                </ul>
              </Alert>
            </div>
          )}
          
          <Form>
            <Form.Group className="mb-4">
  <Form.Label className="fw-bold">Pilih Dosen Pembimbing</Form.Label>
  
  {/* Pembimbing 1 (P1) */}
  <div className="border rounded p-3 mb-3">
    <h6 className="mb-3 border-bottom pb-2">
      <Badge bg="primary" className="me-2">P1</Badge> 
      Pembimbing 1 (Utama)
    </h6>
    
    <Form.Select 
      onChange={handlePembimbingChange} 
      value={selectedPembimbing[0] || ""}
      data-role-index="0"
      className="mb-2"
    >
      <option value="">-- Pilih Pembimbing 1 --</option>
      {dosenList.length > 0 ? (
        dosenList.map(dosen => {
          // Check if this lecturer is a candidate supervisor
          const isCandidate = selectedTA.kandidatPembimbing && 
                            selectedTA.kandidatPembimbing.some(p => p.id === dosen.id);
          
          // Skip if already selected as another role
          const isSelectedAsP2 = selectedPembimbing[1] === dosen.id;
          
          if (isSelectedAsP2) return null;
          
          return (
            <option key={dosen.id} value={dosen.id}>
              {dosen.nama} {dosen.nip && `(${dosen.nip})`} 
              {isCandidate ? ' [Kandidat]' : ''}
            </option>
          );
        })
      ) : null}
    </Form.Select>
    
    <small className="text-primary fw-bold">
      Dosen pembimbing utama (P1) memiliki wewenang mengajukan seminar dan sidang
    </small>
  </div>
  
  {/* Pembimbing 2 (P2) */}
  <div className="border rounded p-3">
    <h6 className="mb-3 border-bottom pb-2">
      <Badge bg="secondary" className="me-2">P2</Badge> 
      Pembimbing 2 (Pendamping)
    </h6>
    
    <Form.Select 
      onChange={handlePembimbingChange} 
      value={selectedPembimbing[1] || ""}
      data-role-index="1"
      className="mb-2"
    >
      <option value="">-- Pilih Pembimbing 2 --</option>
      {dosenList.length > 0 ? (
        dosenList.map(dosen => {
          // Check if this lecturer is a candidate supervisor
          const isCandidate = selectedTA.kandidatPembimbing && 
                            selectedTA.kandidatPembimbing.some(p => p.id === dosen.id);
          
          // Skip if already selected as another role
          const isSelectedAsP1 = selectedPembimbing[0] === dosen.id;
          
          if (isSelectedAsP1) return null;
          
          return (
            <option key={dosen.id} value={dosen.id}>
              {dosen.nama} {dosen.nip && `(${dosen.nip})`} 
              {isCandidate ? ' [Kandidat]' : ''}
            </option>
          );
        })
      ) : null}
    </Form.Select>
    
    <small className="text-muted">
      Pembimbing 2 bersifat opsional
    </small>
  </div>
  
  <Form.Text className="text-muted mt-2">
    <div className="alert alert-info py-2 small mt-2 mb-0">
      <strong>Catatan:</strong> Pertimbangkan untuk memilih dari kandidat yang diajukan mahasiswa.
      Pembimbing tidak boleh sama dengan penguji.
    </div>
  </Form.Text>
</Form.Group>
            
            <div className="alert alert-primary mt-3 mb-0">
              <strong>Catatan:</strong> Penugasan dosen penguji dilakukan pada saat seminar dijadwalkan di menu Kelola Seminar.
            </div>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button 
            variant="primary" 
            onClick={handleApprove}
            disabled={selectedPembimbing.length === 0}
          >
            <FaCheck className="me-2" />
            Setujui dan Tugaskan Pembimbing
          </Button>
          <Button variant="secondary" onClick={() => setShowAssignModal(false)}>
            Batal
          </Button>
        </Modal.Footer>
      </Modal>
    );
  };

  // Modal Penolakan Tugas Akhir
  const renderRejectModal = () => {
    if (!selectedTA) return null;
    
    return (
      <Modal show={showRejectModal} onHide={() => setShowRejectModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Tolak Tugas Akhir</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>Anda akan menolak tugas akhir dengan judul:</p>
          <p className="fw-bold">{selectedTA.judul}</p>
          
          <Form.Group className="mb-3">
            <Form.Label>Komentar Penolakan</Form.Label>
            <Form.Control 
              as="textarea" 
              rows={4} 
              value={rejectComment}
              onChange={(e) => setRejectComment(e.target.value)}
              placeholder="Berikan alasan penolakan dan saran perbaikan untuk mahasiswa"
            />
            <Form.Text className="text-muted">
              Komentar ini akan ditampilkan kepada mahasiswa sebagai panduan untuk perbaikan.
            </Form.Text>
          </Form.Group>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowRejectModal(false)}>
            Batal
          </Button>
          <Button variant="danger" onClick={handleReject}>
            Tolak Tugas Akhir
          </Button>
        </Modal.Footer>
      </Modal>
    );
  };

  // Modal Penolakan Usulan Perubahan
  const renderRejectUsulanModal = () => {
    if (!selectedTA) return null;
    
    return (
      <Modal show={showRejectUsulanModal} onHide={() => setShowRejectUsulanModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Tolak Usulan Perubahan Judul</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>Anda akan menolak usulan perubahan judul:</p>
          <div className="mb-3">
            <p className="mb-1"><strong>Judul Lama:</strong> {selectedTA.judul}</p>
            <p className="mb-1"><strong>Judul Baru (Usulan):</strong> {selectedTA.usulanPerubahan?.judul}</p>
          </div>
          
          <Form.Group className="mb-3">
            <Form.Label>Alasan Penolakan</Form.Label>
            <Form.Control 
              as="textarea" 
              rows={4} 
              value={rejectUsulanComment}
              onChange={(e) => setRejectUsulanComment(e.target.value)}
              placeholder="Berikan alasan penolakan usulan perubahan judul"
            />
            <Form.Text className="text-muted">
              Alasan ini akan ditampilkan kepada mahasiswa sebagai panduan untuk perbaikan.
            </Form.Text>
          </Form.Group>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowRejectUsulanModal(false)}>
            Batal
          </Button>
          <Button variant="danger" onClick={handleRejectUsulanPerubahan}>
            Tolak Usulan Perubahan
          </Button>
        </Modal.Footer>
      </Modal>
    );
  };

  const renderRejectPembimbingModal = () => {
    if (!selectedTA) return null;
    
    return (
      <Modal show={showRejectPembimbingModal} onHide={() => {
        setShowRejectPembimbingModal(false);
        setRejectPembimbingComment('');
      }}>
        <Modal.Header closeButton>
          <Modal.Title>Tolak Usulan Perubahan Pembimbing</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>Anda akan menolak usulan perubahan pembimbing:</p>
          <div className="mb-3">
            <p className="mb-1"><strong>Pembimbing Lama:</strong></p>
            <ul>
              {selectedTA.usulanPerubahanPembimbing?.pembimbingLamaId && 
               Array.isArray(selectedTA.usulanPerubahanPembimbing.pembimbingLamaId) &&
               selectedTA.usulanPerubahanPembimbing.pembimbingLamaId.map((pId, idx) => {
                 const pembimbingLama = Array.isArray(selectedTA.pembimbing) ? 
                                       selectedTA.pembimbing.find(p => p.id === pId) : null;
                 return (
                   <li key={pId}>
                     {pembimbingLama ? `${pembimbingLama.nama} (NIP: ${pembimbingLama.nip || '-'})` : `Pembimbing ${idx+1} (ID: ${pId})`}
                   </li>
                 );
               })}
            </ul>
            <p className="mb-1 mt-2"><strong>Pembimbing Baru (Usulan):</strong></p>
            <ul>
              {selectedTA.usulanPerubahanPembimbing?.pembimbingBaruId && 
               Array.isArray(selectedTA.usulanPerubahanPembimbing.pembimbingBaruId) &&
               selectedTA.usulanPerubahanPembimbing.pembimbingBaruId.map((pId, idx) => {
                 const dosenBaru = dosenList.find(d => d.id === pId);
                 return (
                   <li key={pId}>
                     {dosenBaru ? `${dosenBaru.nama} (NIP: ${dosenBaru.nip || '-'})` : `Pembimbing ${idx+1} (ID: ${pId})`}
                   </li>
                 );
               })}
            </ul>
          </div>
          
          <Form.Group className="mb-3">
            <Form.Label>Alasan Penolakan</Form.Label>
            <Form.Control 
              as="textarea" 
              rows={4} 
              value={rejectPembimbingComment}
              onChange={(e) => setRejectPembimbingComment(e.target.value)}
              placeholder="Berikan alasan penolakan usulan perubahan pembimbing"
            />
            <Form.Text className="text-muted">
              Alasan ini akan ditampilkan kepada mahasiswa sebagai panduan untuk perbaikan.
            </Form.Text>
          </Form.Group>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => {
            setShowRejectPembimbingModal(false);
            setRejectPembimbingComment('');
          }}>
            Batal
          </Button>
          <Button variant="danger" onClick={handleRejectPerubahanPembimbing}>
            Tolak Usulan Perubahan
          </Button>
        </Modal.Footer>
      </Modal>
    );
  };

  return (
    <Container className="py-4">
      <h1 className="mb-4">Kelola Tugas Akhir</h1>
      
      {error && <Alert variant="danger">{error}</Alert>}
      {success && <Alert variant="success">{success}</Alert>}
      
      {loading ? (
        <Alert variant="info">Memuat data...</Alert>
      ) : (
        <Card>
          <Card.Header>
            <ul className="nav nav-tabs card-header-tabs">
              <li className="nav-item">
                <button 
                  className={`nav-link ${activeTab === 'pending' ? 'active' : ''}`}
                  onClick={() => {
                    setActiveTab('pending');
                    if (!loadedTabs.has('pending')) {
                      fetchPendingData();
                    }
                  }}
                >
                  Menunggu Persetujuan
                </button>
              </li>
              <li className="nav-item">
                <button 
                  className={`nav-link ${activeTab === 'approved' ? 'active' : ''}`}
                  onClick={() => {
                    setActiveTab('approved');
                    if (!loadedTabs.has('approved')) {
                      fetchApprovedData();
                    }
                  }}
                >
                  Disetujui
                </button>
              </li>
            </ul>
          </Card.Header>
          <Card.Body>
            {activeTab === 'pending' ? renderPendingTable() : renderApprovedTable()}
          </Card.Body>
        </Card>
      )}
      
      {renderDetailModal()}
      {renderAssignModal()}
      {renderRejectModal()}
      {renderRejectUsulanModal()}
      {renderRejectPembimbingModal()}
    </Container>
  );
};

export default KelolaTugasAkhir;
